import React from "react";
import PropTypes from "prop-types";
import { Grid, Skeleton, Typography } from "@mui/material";
import { SearchInput } from "app/components";
import { FormattedMessage, injectIntl } from "react-intl";
import { DivRootStyled } from "./InsurersToolbar.styles";
const InsurersToolbar = (props) => {
  const { className, handleSearch, intl, totalCount, initialSearchQuery } = props;
  return /* @__PURE__ */ React.createElement(DivRootStyled, { className }, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 3 }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "menu.insurers" })), /* @__PURE__ */ React.createElement(Typography, { variant: "subtitle2", textTransform: "uppercase" }, typeof totalCount !== "undefined" ? /* @__PURE__ */ React.createElement(FormattedMessage, { id: "insurers.totalCount", values: { totalCount } }) : /* @__PURE__ */ React.createElement(Skeleton, { width: 200 }))), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(
    SearchInput,
    {
      onChange: handleSearch,
      placeholder: intl.formatMessage({ id: "insurers.search" }).toUpperCase(),
      initialSearchQuery
    }
  ))));
};
InsurersToolbar.propTypes = {
  className: PropTypes.string,
  handleSearch: PropTypes.func.isRequired
};
export default injectIntl(InsurersToolbar);
